interface IconProps {
  fillColor: string
}

// Padlock with a keyhole, from Adam Grasza's Selecta age-verification Figma (passkey screen). The
// viewBox keeps the export's coordinates, centred on the lock.
export const PasskeyLockIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="80"
        height="80"
        viewBox="162 314 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M202 318.283C211.067 318.283 218.417 325.634 218.417 334.7V348.033H218.667C224.19 348.033 228.667 352.511 228.667 358.033V379.7C228.667 385.223 224.19 389.7 218.667 389.7H185.333C179.81 389.7 175.333 385.223 175.333 379.7V358.033C175.333 352.511 179.81 348.033 185.333 348.033H185.583V334.7C185.583 325.634 192.933 318.283 202 318.283ZM185.333 350.867C181.572 350.867 178.489 353.765 178.192 357.45H203.667C204.449 357.45 205.083 358.085 205.083 358.867C205.083 359.649 204.449 360.283 203.667 360.283H178.167V379.7C178.167 383.658 181.375 386.867 185.333 386.867H218.667C221.839 386.867 224.527 384.806 225.471 381.95H200.333C199.551 381.95 198.917 381.316 198.917 380.533C198.917 379.751 199.551 379.117 200.333 379.117H225.833V358.033C225.833 354.075 222.625 350.867 218.667 350.867H185.333ZM202 364.7C204.761 364.7 207 366.939 207 369.7C207 372.462 204.761 374.7 202 374.7C199.239 374.7 197 372.462 197 369.7C197 366.939 199.239 364.7 202 364.7ZM202 367.533C200.803 367.533 199.833 368.504 199.833 369.7C199.833 370.897 200.803 371.867 202 371.867C203.197 371.867 204.167 370.897 204.167 369.7C204.167 368.504 203.197 367.533 202 367.533ZM202 321.117C194.498 321.117 188.417 327.198 188.417 334.7V348.033H192.25V334.7C192.25 329.315 196.615 324.95 202 324.95C207.385 324.95 211.75 329.315 211.75 334.7V348.033H215.583V334.7C215.583 327.198 209.502 321.117 202 321.117ZM202 327.783C198.18 327.783 195.083 330.88 195.083 334.7V348.033H208.917V334.7C208.917 330.88 205.82 327.783 202 327.783Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
